import { cmsDataService } from './content'
import { FunctionComponent, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { OccContext } from './content/components'
import { scrollToHashElement } from './content/utilities'
import { PagesRouter } from './routing/PagesRouter'
import { isMemberSignedIn, loadMember, signMemberOut } from '@vista-digital/occ-domain'

interface AppOverrideProps {
    pagesRouterOverride?: FunctionComponent
}

export const App: FunctionComponent<AppOverrideProps> = props => {
    const PagesRouterElement = props.pagesRouterOverride ?? (() => <PagesRouter />)

    useEffect(() => {
        const signedIn = isMemberSignedIn()

        if (signedIn) {
            loadMember()
                .then(member => {
                    console.warn(member)
                })
                .catch(error => {
                    signMemberOut()
                    console.warn(error, 'there was a problem loading member data indicating the auth token is invalid')
                })
        }
    }, [])

    return (
        <OccContext>
            <Helmet>
                <title>{cmsDataService.get().siteTitle}</title>
            </Helmet>
            <PagesRouterElement />
        </OccContext>
    )
}
